export default __webpack_public_path__ + "static/media/resto.3cd221bd.jpeg";